import React, { useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { ButtonModel } from "../Models/ButtonModel";
import { useNavigate } from "react-router-dom";

import "./Button.css";
import Utils from "../Utils/Utils";

interface ButtonProps {
  blok: ButtonModel;
  onButtonClick?: () => void;
  onButtonMouseEnter?: () => void;
  onButtonMouseLeave?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  blok,
  onButtonClick,
  onButtonMouseEnter,
  onButtonMouseLeave,
}) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
    if (onButtonMouseEnter) {
      onButtonMouseEnter();
    }
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
    if (onButtonMouseLeave) {
      onButtonMouseLeave();
    }
  };
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (onButtonClick) {
      onButtonClick();
    }

    if (blok.link?.cached_url) {
      let scrollTo = "";
      if (blok.scrollTo && blok.scrollTo.length > 0) {
        scrollTo = `?scrollToName=${
          blok.scrollTo[0].blokName
        }&scrollToIndex=${blok.scrollTo[0].index?.toString()}`;
      }
      if (blok.link?.linktype === "story") {
        navigate(`/${blok.link.cached_url}${scrollTo}`);
      } else {
        const url = new URL(
          `${blok.link.cached_url}${scrollTo}`,
          window.location.origin
        );
        window.location.href = url.href;
      }
    } else {
      if (blok.scrollTo && blok.scrollTo.length > 0) {
        Utils.setNavidation([
          { param: "scrollToName", value: blok.scrollTo[0].blokName },
          { param: "scrollToIndex", value: blok.scrollTo[0].index?.toString() },
        ]);
        Utils.scrollTo(blok.scrollTo[0].blokName, blok.scrollTo[0].index);
      }
    }
  };

  const url = blok.link?.cached_url
    ? blok.link?.linktype === "story"
      ? `/${blok.link.cached_url}`
      : blok.link.cached_url
    : undefined;

  return (
    <div className="button-container" {...storyblokEditable(blok)}>
      <a
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        href={url}
        className="button"
        style={{
          color: blok.textColor,
          backgroundColor: isHovered ? blok.hoverColor : blok.color,
          borderColor: blok.borderColor ? blok.borderColor : "",
        }}
      >
        {blok.label}
      </a>
    </div>
  );
};

export default Button;
